import { FormStatusType } from '@/api/dtos';

export const crfReadOnly = (canUpdate: boolean) =>
    (info: { initialValue?: unknown }): boolean =>
        !canUpdate || (info.initialValue as { formStatus?: FormStatusType } | undefined)?.formStatus === FormStatusType.Locked;
